var _rect, _path, _rect2, _rect3, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFinishing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 27,
    rx: 8,
    fill: "currentColor",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4324 12.04H16.1149V6.64005C16.1149 5.38005 15.4324 5.12505 14.5999 6.07005L13.9999 6.75255L8.92239 12.5275C8.22489 13.315 8.51739 13.96 9.56739 13.96H11.8849V19.36C11.8849 20.62 12.5674 20.875 13.3999 19.93L13.9999 19.2475L19.0774 13.4725C19.7749 12.685 19.4824 12.04 18.4324 12.04Z",
    fill: "currentColor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15.5,
    width: 6.66667,
    height: 7,
    rx: 3.33333,
    fill: "#E6F7F6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15.5,
    width: 6.66667,
    height: 7,
    rx: 3.33333,
    stroke: "#E6F7F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 16C15.7679 16 14.5 17.3425 14.5 19C14.5 19.5625 14.6487 20.095 14.9108 20.545C15.3996 21.415 16.2992 22 17.3333 22C18.3675 22 19.2671 21.415 19.7558 20.545C20.0179 20.095 20.1667 19.5625 20.1667 19C20.1667 17.3425 18.8987 16 17.3333 16ZM18.7996 18.6775L17.2908 20.155C17.1917 20.2525 17.0571 20.305 16.9296 20.305C16.795 20.305 16.6604 20.2525 16.5542 20.14L15.8529 19.3975C15.6475 19.18 15.6475 18.82 15.8529 18.6025C16.0583 18.385 16.3983 18.385 16.6037 18.6025L16.9438 18.9625L18.0771 17.8525C18.2896 17.6425 18.6296 17.6575 18.8279 17.8825C19.0263 18.1075 19.0121 18.46 18.7996 18.6775Z",
    fill: "#2E9E3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishing);
export default __webpack_public_path__ + "static/media/finishing.dde3b79fb6a51c9efc4ee6a1ab750c22.svg";
export { ForwardRef as ReactComponent };